import { Card, Descriptions, Table, Tag, Button, List, Space, Typography, Divider, Flex, Col, Badge, Row, Popover } from "antd";
import dayjs from "dayjs";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { format, formatDistanceToNow } from "date-fns";
import ActionModal from "../components/ActionModal";
import { Show } from "@refinedev/antd";
import { useShow } from "@refinedev/core";
import { IconDisplay } from "../../../components/IconDisplay";

const formatDate = (timestamp: number | null) => {
	if (!timestamp) return "N/A";
	return dayjs(Math.floor(timestamp / 1e6)).format("MM/dd/yy hh:mm a");
};

const { Title, Text } = Typography;

export const ReportContentShow = () => {
  const { id } = useParams(); // Assuming you use a routing system like React Router
  const navigate = useNavigate();
  const { query } = useShow({
    resource: "report",
    id,
  });

	const { data, isLoading } = query;
    const report: ReportRecord = data?.data.data;

    // console.log("Report", report)
    return (
        <Show title="Reported Content Details" isLoading={isLoading}>
          <Card style={{ padding: 5 }}>
            <Title level={4}>User details</Title>
            {/* User details */}
            <Row gutter={60} align="top" justify="start" style={{ marginLeft: 20}} >
              {/* Creator Info */}
              <Row align="middle" style={{ marginRight: 30}}>
                <Space
                  style={{
                    border: '1px solid gray',
                    borderRadius: '50%',
                    width: 100,
                    height: 100
                  }}
                >
                  {report?.entityCreator.custom.profilePictureURL && (
                    <IconDisplay
                      iconURL={report?.entityCreator.custom.profilePictureURL || ""}
                      width={100}
                      height={100}
                      borderRadius="50%"
                    />
                  )}
                  
                </Space>
                    
                <Space direction="vertical" style={{ marginLeft: 10}}>
                  <Text 
                    onClick={() => {
                      navigate(`/users/${report.entityCreator.id}`);
                    }}
                    style={{
                      cursor: 'pointer',
                      textDecoration: 'none',
                      fontSize: 20
                      }}
                      onMouseEnter={(e) => {
                          e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseLeave={(e) => {
                          e.currentTarget.style.textDecoration = 'none';
                      }}>
                        {report?.entityCreator.custom.fullName}
                      </Text>
                  <Text style={{ fontSize: 15 }}>username: @{report?.entityCreator.custom.username}</Text>
                  {report?.entityCreatorUser && (
                    <Tag
                     style={{
                       backgroundColor: report?.entityCreatorUser?.isActive ? "green" : "orange",
                       color: "#FFFFFF",
                       width: 69,
                       textAlign: 'center',
                       fontSize: 13
                     }}
                    >
                     {report?.entityCreatorUser?.isActive ? "Active" : "Inactive"}
                    </Tag>
                  )}
                </Space>
              </Row>
                      

              {/* User since */}
              <Col style={{ marginTop: 10}}>
                  <Title level={5}>User since</Title>
                  <div
                  >
                    {!isLoading && (
                      <Popover content={formatDate(report?.entityCreator.createdAt || null)}>
                        <span>
                            {formatDistanceToNow(format(report?.entityCreator.createdAt / 1e6, "MM/dd/yy hh:mm a"))} ago
                        </span>
                      </Popover>
                    )}
                    
                  </div>
              </Col>
              {/* Ban Count */}
              <Col style={{ marginTop: 10 }}>
                <Title level={5}>Ban Count</Title>
                {report?.entityCreator?.banCount ? (
                  <Badge
                    count={report?.entityCreator?.banCount}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      fontSize: 18,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "red",
                    }}
                  />
                ) : (                    
                  <Tag
                    style={{
                      borderRadius: '50%',
                      color: "#FFFFFF",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 17,
                      width: 30,
                      height: 30,
                    }}
                  >
                    0
                  </Tag>
                )}
              </Col>
                  
              {/* Removed Content Count */}
              <Col style={{ marginTop: 10 }}>
                <Title level={5}>Removed Content Count</Title>
                {report?.entityCreator?.deletedContentCount ? (
                  <Badge
                    count={report?.entityCreator?.deletedContentCount}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: "50%",
                      fontSize: 18,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "gray",
                    }}
                  />
                ) : (                    
                  <Tag
                    style={{
                      borderRadius: '50%',
                      backgroundColor: 'gray',
                      color: "#FFFFFF",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontSize: 17,
                      width: 30,
                      height: 30,
                    }}
                  >
                    0
                  </Tag>
                )}
              </Col>
            </Row>


            {/* Report */}
            <Divider />

            <Title level={4}>Report details</Title>
            <Row gutter={50} align="top" justify="start">
              {/* Date */}
              <Col style={{ marginBottom: 20, marginLeft: 50 }}>
                <Title level={5}>Date</Title>
                {!isLoading && (
                  <Popover content={format(report?.createdAt, "MM/dd/yy hh:mm a")}>
                    <span>
                        {formatDistanceToNow(new Date(report?.createdAt) || new Date())} ago
                    </span>
                  </Popover>
                )}
              </Col>

              {/* Reporter */}
              <Col style={{ marginBottom: 20, marginLeft: 50  }}>
                <Title level={5}>Reporter</Title>
                <Text>Automod</Text>
              </Col>

              {/* Reason */}
              {/* <Col style={{ marginBottom: 20, marginLeft: 50  }}>
                <Title level={5}>Reason</Title>
                <Tag>{report?.}</Tag>
              </Col> */}

              {/* Type */}
              <Col style={{ marginBottom: 20, marginLeft: 50  }}>
                <Title level={5}>Type</Title>
                {report && report.flags.map((flag: any) => (
                   <Tag>{flag.type}</Tag>
                ))}
              </Col>

              {/* Reviewed by*/}
              <Col style={{ marginBottom: 20, marginLeft: 50  }}>
                <Title level={5}>Reviewed by</Title>
                {report?.reviewedByUser ? (
                  <Text>{report?.reviewedBy}</Text>
                ) : (
                  <Text>Not reviewed yet</Text>
                )}
              </Col>

              {/* Reviewe date*/}
              {report?.reviewedBy.length > 0 && (
                <Space direction="vertical" style={{ marginBottom: 20, marginLeft: 50  }}>
                  <Title level={5}>Reviewe date</Title>
                  {!isLoading && (
                    <Popover content={format(report?.reviewedAt, "MM/dd/yy hh:mm a")}>
                      <span>
                          {formatDistanceToNow(new Date(report?.reviewedAt) || new Date())} ago
                      </span>
                    </Popover>
                  )}
                </Space>
              )}
            </Row>
    
            <Divider />

            {/* Flags */}
            <Title level={5}>Flags</Title>
            <List
              dataSource={report?.flags || []}
              renderItem={(flag: any) => <Tag key={flag}>{flag.labels}</Tag>}
            />
    
            <Divider />

            {/* Content */}
            <Title level={4}>Content</Title>
            <Row gutter={40} align="top" justify="start">
              <Col>
                <Title level={5}>Text</Title>
                <Text>
                  {report?.moderationPayload?.texts?.join(", ") || "No text content provided."}
                </Text>
              </Col>

              {/* <Col>
                <Title level={5}>Image</Title>
                <Text>
                  {report?.moderationPayload?.texts?.join(", ") || "No text content provided."}
                </Text>
              </Col> */}
            </Row>

            
            {/* TODO: Show full context */}
            {/* TODO: Show image and video */}
    
            <Divider />

            {/* Logs */}
            <Title level={5}>Action Log</Title>
            {/* Action log */}
            <Space direction="vertical" style={{ marginBottom: 20 }}>
              {report && report.actions.map((action: any) => (
                <Text>{action.type}</Text>
              ))}
            </Space>
          </Card>
        </Show>
      );
};
